import { USER_TYPE } from "../constant/app.data.constant";
import icDashboardB from "../assets/images/icDashboardB.png";
import icDashboardW from "../assets/images/icDashboardW.png";
import icDashboardBlue from "../assets/images/icDashboardBlue.png";
import icBillerDirectoryB from "../assets/images/icBillerDirectoryB.png";
import icBillerDirectoryW from "../assets/images/icBillerDirectoryW.png";
import messageBillerBlack from "../assets/images/messageBillerBlack.png";
import messageBillerWhite from "../assets/images/messageBillerWhite.png";
import icPractitionerProfileB from "../assets/images/icPractitionerProfileB.png";
import icPractitionerProfileW from "../assets/images/icPractitionerProfileW.png";
import icPractitionerProfileBlue from "../assets/images/icPractitionerProfileBlue.png";
import icLogoutB from "../assets/images/icLogoutB.png";
import icLogoutW from "../assets/images/icLogoutW.png";
import icBillRequestB from "../assets/images/ic-Bill-Request-b.png";
import icBillRequestW from "../assets/images/ic-Bill-Request-w.png";
import icUploadBillB from "../assets/images/icUploadBillB.png";
import icUploadBillW from "../assets/images/icUploadBillW.png";
import icUploadBillBlue from "../assets/images/icUploadBillBlue.png";
import icManageProviderB from "../assets/images/icManageProviderB.png";
import icManageProviderW from "../assets/images/icManageProviderW.png";
import icManageProviderBlue from "../assets/images/icManageProviderBlue.png";
import icManageUserB from "../assets/images/icManageUserB.png";
import icManageUserW from "../assets/images/icManageUserW.png";
import icManageInsuranceCoB from "../assets/images/icManageInsuranceCoB.png";
import icManageInsuranceCoW from "../assets/images/icManageInsuranceCoW.png";
import ichelpb from "../assets/images/ichelpb.png";
import ichelpw from "../assets/images/ichelpw.png";
const routes = {
  initialRoute: "main",
  routes: {
    main: {
      initialRoute: "/login",  // TEST PR
      type: "stack",
      routes: {
        landing: {
          path: "/",
          metadata: {
            public: true,
          },
        },
        kcsession: {
          path: '/kcsession/:application',
          metadata: {
            public: true,
          },
        },
        login: {
          path: "/login",
          metadata: {
            public: true,
          },
        },
        unauthorize: {
          path: "/unauthorize/:content",
          metadata: {
            public: true,
          },
        },
        login3: {
          path: "/login3",
          metadata: {
            public: true,
          },
        },
        pchLogin: {
          path: "/claims/login",
          metadata: {
            public: true,
          },
        },
        changePassword: {
          path: "/changePassword",
          metadata: {
            public: true,
          },
        },
        pchChangePassword: {
          path: "/claims/changePassword",
          metadata: {
            public: true,
          },
        },
        forgotPassword: {
          path: "/forgotPassword",
          metadata: {
            public: true,
          },
        },
        pchForgotPassword: {
          path: "/claims/forgotPassword",
          metadata: {
            public: true,
          },
        },
        forgotUsername: {
          path: "/forgotUsername",
          metadata: {
            public: true,
          },
        },
        registration: {
          path: "/registration/:type",
          metadata: {
            public: true,
          },
        },
        pchSignup: {
          path: "/claims/registration/:type",
          metadata: {
            public: true,
          },
        },
        pchSignupConfirmation: {
          path: "/claims/registration/confirm",
          metadata: {
            public: true,
          },
        },
        helps: {
          path: `/claims/helps`,
          metadata: {
            public: true,
          },
        },
        external: {
          path: "/scanBill/:threadId",
          action: "externalScannerAction",
          metadata: {
            public: true,
          },
        },
        externalBills: {
          path: "/claims/uploaded-bills/:type/:uid",
          action: "uploadedBillAction",
          metadata: {
            public: true,
          },
        },
        textToPay: {
          path: "/t2p/:messageMetaIdentifier",
          action: "textToPayAction",
          metadata: {
            public: true,
          },
        },
        pchTermsAndconditionsRoute: {
          path: `/claims/termsandconditions`,
          action: "pchTermsAndconditionsAction",
          metadata: {
            public: true,
          },
        },
        pchPrivacyPolicyRoute: {
          path: `/claims/privacypolicy`,
          action: "pchPrivacyPolicy",
          metadata: {
            public: true,
          },
        },
        pchusertermsRoute: {
          path: `/claims/userterms`,
          action: "pchuserterms",
          metadata: {
            public: true,
          },
        },
        accessServicesAgreementRoute: {
          path: `/claims/accessServicesAgreement`,
          action: "accessServicesAgreement",
          metadata: {
            public: true,
          },
        },
        termsAndConditionsScreenRoute: {
          path: `/claims/termsAndConditions`,
          action: "termsAndConditionsScreen",
          metadata: {
            public: true,
          },
        },
        termsAndconditionsRoute: {
          path: `/termsandconditions`,
          action: "termsAndconditionsAction",
          metadata: {
            public: true,
          },
        },
        privacyPolicyRoute: {
          path: `/privacypolicy`,
          action: "pchPrivacyPolicy",
          metadata: {
            public: true,
          },
        },

        privateNavigator: {
          type: "stack",
          routes: {
            homeNavigator: {
              type: "stack",
              initialRoute: "dashboardNavigator",
              routes: {
                dashboardNavigator: {
                  type: "stack",
                  label: "Dashboard",
                  icon: "moniter",
                  iconPath: icDashboardB,
                  whiteIconPath: icDashboardW,
                  blueIconPath: icDashboardBlue,
                  userType: [USER_TYPE.PCH_PATIENT, USER_TYPE.XBP, USER_TYPE.SMB, USER_TYPE.XBPSMB],
                  routes: {
                    dashboard: {
                      path: `/dashboard`,
                      label: "Dashboard",
                      action: "dashboard",
                    },
                    makePaymentRoutes: {
                      path: `/make-payment`,
                      label: "All Bills",
                      action: "makePaymentAction",
                    },
                    bulkPaymentRoutes: {
                      path: `/bulk-payment`,
                      label: "Bulk Payment",
                      action: "bulkPaymentAction",
                    }, 
                    uploadedBillsRoute: {
                      path: `/claims/medical-bills/:uid`,
                      action: "viewBillDetailsAction",
                      label: "Uploaded Bill",
                    },
                    sepaBillsRoute: {
                      path: `/sepa-bills`,
                      label: "SEPA Bills",
                      action: "sepaBillAction",
                    },
                    sepaBillDetailsRoute: {
                      path: `/sepa-bill-details/:resourceId`,
                      label: "Bill Details",
                      action: "sepaBillDetail",
                    },
                    deleteAccountRoute: {
                      path: `/delete-account`,
                      label: "Delete Account",
                      action: "deleteAccountAction",
                    }
                  },
                },
                paymentOptionsNavigator: {
                  type: "stack",
                  // label: "Payment Options",
                  // icon: "cloudSync",
                  userType: [USER_TYPE.XBP],
                  routes: {
                    paymentOptionsRoute: {
                      path: `/payment-options`,
                      label: "Payment Options",
                      action: "paymentOptionsAction",
                    },
                  },
                },
                billNavigator: {
                  type: "stack",
                  userType: [USER_TYPE.XBP, USER_TYPE.XBPSMB],
                  routes: {
                    billDetailsRoute: {
                      path: `/bill-details/:threadId`,
                      label: `Bill Details`,
                      action: "billDetailsAction",
                    },
                    billHistoryDetailsRoute: {
                      path: `/bill-history-details/:threadId`,
                      label: `History Details`,
                      action: "billDetailsAction",
                    },
                  },
                },
                billersDirectoryNavigator: {
                  type: "stack",
                  label: "Payer Authorization",
                  icon: "cloudSync",
                  iconPath: icBillerDirectoryB,
                  whiteIconPath: icBillerDirectoryW,
                  userType: [USER_TYPE.XBP, USER_TYPE.XBPSMB],
                  routes: {
                    billersDirectoryRoute: {
                      path: `/directory`,
                      label: "Payer Authorization",
                      action: "billersDirectoryScreenAction",
                    },
                    pamMessageRoute: {
                      path: `/pam-message/:pamId/:pid`,
                      label: "PAM Message",
                      action: "pamMessageAction",
                    },
                  },
                },

                simpleMessageNavigator: {
                  type: "stack",
                  label: "Message Biller",
                  icon: "message",
                  iconPath: messageBillerBlack,
                  whiteIconPath: messageBillerWhite,
                  userType: [USER_TYPE.XBP, USER_TYPE.XBPSMB],
                  routes: {
                    simpleMessageRoute: {
                      path: `/simple-message`,
                      label: "Message Biller",
                      action: "simpleMessageScreenAction",
                    },
                    simpleMessageDetailRoute: {
                      path: `/simple-message/:threadId`,
                      label: "Message",
                      action: "simpleMessagesDetailsAction",
                    },
                    addMessageScreenRoute: {
                      path: `/simple-message/createmessage`,
                      action: "createMessageAction",
                      label: "Add Message",
                    },
                  },
                },
                messageScreenNavigator: {
                  type: "stack",
                  routes: {
                    messageScreenRoute: {
                      path: `/messages/:threadId`,
                      action: "messageScreenAction",
                      label: "Messages",
                    },
                  },
                },
                billHistoryScreenNavigator: {
                  type: "stack",
                  routes: {
                    billHistoryScreenRoute: {
                      path: `/bill-history/:billerPid`,
                      action: "billHistoryScreenAction",
                      label: "History",
                    },
                  },
                },
                notificationScreenNavigator: {
                  type: "stack",
                  routes: {
                    notificationScreenRoute: {
                      path: `/notification`,
                      action: "notificationScreenAction",
                      label: "Notifications",
                    },
                  },
                },
                billRequestScreenNavigator: {
                  type: "stack",
                  // label: "Find/Link Biller",
                  icon: "powerPlug",
                  iconPath: icBillRequestB,
                  whiteIconPath: icBillRequestW,
                  blueIconPath: icBillRequestB,
                  userType: [USER_TYPE.XBP, USER_TYPE.XBPSMB],
                  routes: {
                    billRequestScreenRoute: {
                      path: `/bill-request`,
                      action: "billRequestScreenAction",
                      label: "Find/Link Biller",
                    },
                  },
                },
                uploadBillScreenNavigator: {
                  type: "stack",
                  label: "Upload Bill",
                  icon: "arrowUp",
                  iconPath: icUploadBillB,
                  whiteIconPath: icUploadBillW,
                  blueIconPath: icUploadBillBlue,
                  userType: [USER_TYPE.PCH_PROVIDER, USER_TYPE.PCH_PATIENT],
                  routes: {
                    uploadBillsRoute: {
                      path: `/claims/upload-bills`,
                      action: "uploadBillScreenAction",
                      label: "Upload Bill",
                    },
                    submittedReceiptRoute: {
                      path: `/claims/submitted-receipt/:uid`,
                      label: "Claim Details",
                      action: "submittedReceipt",
                    },
                    externalClientUploadBillRoute: {
                      path: "/claims/external-upload-bill/:appointment/:redirect_url/:access_token",
                      action: "externalUploadBillAction",
                      label: "Uploaded Bill",
                      metadata: {
                        public: true,
                      }
                    },
                    externalClientbillViewRoute: {
                      path: "/claims/external-view-bill/:appointment/:redirect_url/:access_token",
                      action: "externalViewBillAction",
                      label: "Submitted Bill",
                      metadata: {
                        public: true,
                      }
                    },
                    externalClientbillHistoryRoute: {
                      path: "/claims/external-bill-history/:appointment/:redirect_url/:access_token",
                      label: "Bill History",
                      action: "externalHistroyBillAction",
                      metadata: {
                        public: true,
                      }
                    },
                    pchGlobalAccessRoute: {
                      path: "/pch-global/upload-bill/:redirect_url/:access_token",
                      action: "pCHGlobalUploadBillAction",
                      label: "Uploaded Bill",
                      metadata: {
                        public: true,
                      }
                    },
                  },
                },
                managePaymentScreenNavigator: {
                  type: "stack",
                  label: "Manage Payment",
                  icon: "arrowUp",
                  iconPath: icUploadBillB,
                  whiteIconPath: icBillRequestW,
                  blueIconPath: icBillRequestW,
                  userType: [USER_TYPE.PCH_PATIENT],
                  routes: {
                    managePaymentsRoute: {
                      path: `/claims/manage-payment`,
                      action: "managePaymentScreenAction",
                      label: "Manage Payment",
                    },
                    viewPaymentRoute: {
                      path: `/claims/manage-payment/view/:uid`,
                      label: "View Payment",
                      action: "viewManagePaymentAction",
                    },
                    applyPaymentRoute: {
                      path: `/claims/manage-payment/apply/:uid`,
                      label: "Apply Payment",
                      action: "applyManagePaymentAction",
                    },
                  },
                },
                providerListScreenNavigator: {
                  type: "stack",
                  label: "Manage Provider",
                  icon: "cloudSync",
                  iconPath: icManageProviderB,
                  whiteIconPath: icManageProviderW,
                  blueIconPath: icManageProviderBlue,
                  userType: [USER_TYPE.PCH_PROVIDER, USER_TYPE.PCH_PATIENT],
                  routes: {
                    providerListRoute: {
                      path: `/claims/manage-provider`,
                      action: "manageProviderAction",
                      label: "Manage Provider",
                    },
                    addProviderRoute: {
                      path: `/claims/manage-provider/:mode`,
                      action: "manageProviderAction",
                      label: "Manage Provider",
                    },
                  },
                },
                manageUsersNavigator: {
                  type: "stack",
                  // label: "Manage User",
                  icon: "accountCircle",
                  iconPath: icManageUserB,
                  whiteIconPath: icManageUserW,
                  blueIconPath: icPractitionerProfileBlue,
                  userType: [USER_TYPE.PCH_PROVIDER],
                  routes: {
                    //PCH profileview
                    addUsersRoute: {
                      path: `/claims/add-user`,
                      label: "Manage User",
                      action: "manageUsersAction",
                    },
                    editUsersRoute: {
                      path: `/claims/edit-user/:uid`,
                      label: "Edit User",
                      action: "userEditAction",
                    },
                  },
                },
                insuranceListScreenNavigator: {
                  type: "stack",
                  label: "Manage Insurance Co",
                  icon: "cloudSync",
                  iconPath: icManageInsuranceCoB,
                  whiteIconPath: icManageInsuranceCoW,
                  blueIconPath: icManageInsuranceCoB,
                  userType: [USER_TYPE.PCH_PATIENT],
                  routes: {
                    insuranceListRoute: {
                      path: `/claims/manage-insurance`,
                      action: "insuranceListAction",
                      label: "Insurance Co.",
                    },
                    addInsuranceRoute: {
                      path: `/claims/manage-insurance/:mode`,
                      label: "Insurance Co.",
                      action: "insuranceListAction",
                    },
                  },
                },
                pchdashboardNavigator: {
                  type: "stack",
                  label: "Bill History",
                  icon: "moniter",
                  iconPath: icDashboardB,
                  whiteIconPath: icDashboardW,
                  blueIconPath: icDashboardBlue,
                  userType: [USER_TYPE.PCH_PROVIDER],
                  routes: {
                    dashboard: {
                      path: `/dashboard`,
                      label: "Bill History",
                      action: "dashboard",
                    },
                    uploadedBillsRoute: {
                      path: `/claims/medical-bills/:uid`,
                      action: "viewBillDetailsAction",
                      label: "Uploaded Bill",
                    }
                  },
                },
                providerDetailNavigator: {
                  type: "stack",
                  label: "Practice Group Profile",
                  icon: "accountCircle",
                  iconPath: icPractitionerProfileB,
                  whiteIconPath: icPractitionerProfileW,
                  blueIconPath: icPractitionerProfileBlue,
                  userType: [USER_TYPE.PCH_PROVIDER],
                  routes: {
                    //PCH profileview
                    pchProfileViewRoute: {
                      path: `/claims/profile-view`,
                      label: "Profile",
                      action: "pchProfileViewAction",
                    },
                    pchProfileEditRoute: {
                      path: `/claims/profile-edit/:mode`,
                      label: "Edit Profile",
                      action: "pchProfileEditAction",
                    },
                  },
                },
                patientDetailNavigator: {
                  type: "stack",
                  label: "Patient Profile",
                  icon: "accountCircle",
                  iconPath: icPractitionerProfileB,
                  whiteIconPath: icPractitionerProfileW,
                  blueIconPath: icPractitionerProfileBlue,
                  userType: [USER_TYPE.PCH_PATIENT],
                  routes: {
                    //PCH profileview
                    pchProfileViewRoute: {
                      path: `/claims/profile-view`,
                      label: "Profile",
                      action: "pchProfileViewAction",
                    },
                    pchProfileEditRoute: {
                      path: `/claims/profile-edit`,
                      label: "Edit Profile",
                      action: "pchProfileEditAction",
                    },
                  },
                },                
                pchGlobalNavigator: {
                  type: "stack",
                  label: "PCH Global",
                  icon: "accountCircle",
                  iconPath: icManageUserB,
                  whiteIconPath: icManageUserW,
                  blueIconPath: icPractitionerProfileBlue,
                  userType: [USER_TYPE.PCH_PROVIDER],
                  routes: {
                    pchGlobal: {
                      path: `/claims/pch-global`,
                      label: "PCH Global",
                      action: "navPCHGlobalAction",
                    },
                  },
                },
                moopNavigator: {
                  type: "stack",
                  label: "MOOP",
                  icon: "moniter",
                  iconPath: icDashboardB,
                  whiteIconPath: icDashboardW,
                  blueIconPath: icDashboardBlue, 
                  userType: [USER_TYPE.PCH_PATIENT],
                  routes: {
                    moopRoute: {
                      path: `/claims/moop`,
                      label: "MOOP (Member Out of Pocket)",
                      action: "moopAction",
                    },
                  },
                },
                
                helpNavigator: {
                  type: "stack",
                  label: "Help",
                  icon: "accountCircle",
                  iconPath: ichelpb,
                  whiteIconPath: ichelpw,
                  userType: [USER_TYPE.PCH_PROVIDER, USER_TYPE.PCH_PATIENT],
                  routes: {
                    //PCH profileview
                    helpRoute: {
                      path: `/claims/help`,
                      label: "Help",
                      action: "helpScreenAction",
                    },
                  },
                },
                payNowNavigator: {
                  type: "stack",
                  routes: {
                    payTypeRoute: {
                      path: `/payment/:paytype`,
                      label: "Bill Payment",
                      action: "payTypeAction",
                    },
                    payPartialRoute: {
                      path: `/paypart/:paytype`,
                      label: "Bill Pay Part",
                      action: "payTypeAction",
                    },
                    declinedRoute: {
                      path: `/declined/:paytype`,
                      label: "Decline Bill",
                      action: "declinedAction",
                    },
                    extensionRoute: {
                      path: `/request/:paytype`,
                      label: "Extension Request",
                      action: "extensionAction",
                    },
                    billReceiptRoute: {
                      path: `/bill-receipt/:threadId`,
                      label: "Bill Details",
                      action: "billReceiptAction",
                    },
                    checkout: {
                      path: `/stripe/c/pay/:data`,
                      action: "checkoutPayment",
                      label: "Checkout",
                    },
                    paymentReceipt: {
                      path: `/pay/receipts`,
                      action: "paymentReceipt",
                      label: "Receipts",
                    },
                    addNewCardRoute: {
                      path: `/add-new-card`,
                      label: "Add New Card",
                      action: "addNewCardAction",
                    },
                    addNewAccountRoute: {
                      path: `/add-new-account`,
                      label: "Add New Account",
                      action: "addNewAccountAction",
                    },
                    editAccountRoute: {
                      path: `/edit-account/:uid`,
                      label: "Edit Account",
                      action: "editAccountAction",
                    },
                  },
                },
                myBanksNavigator: {
                  type: "stack",
                  // label: "My Banks",
                  icon: "cloudSync",
                  iconPath: icManageInsuranceCoB,
                  whiteIconPath: icManageInsuranceCoW,
                  blueIconPath: icManageInsuranceCoB,
                  userType: [USER_TYPE.XBP, USER_TYPE.XBPSMB],
                  routes: {
                    myBanksRoute: {
                      path: `/my-banks`,
                      label: "My Banks",
                      action: "bankAccountAction",
                    },
                  },
                },
                uploadBillNavigator: {
                  type: "stack",
                  label: "Upload Bill",
                  icon: "cloudSync",
                  iconPath: icUploadBillB,
                  whiteIconPath: icUploadBillW,
                  blueIconPath: icUploadBillBlue,
                  userType: [USER_TYPE.SMB, USER_TYPE.XBPSMB],
                  routes: {
                    uploadBillRoute: {
                      path: `/smb/upload-bill`,
                      label: "Upload Bill",
                      action: "uploadBillAction",
                    },
                  },
                },
                scanQRcodeNavigator: {
                  type: "stack",
                  label: "Scan QR Code",
                  icon: "cloudSync",
                  iconPath: icManageInsuranceCoB,
                  whiteIconPath: icManageInsuranceCoW,
                  blueIconPath: icManageInsuranceCoB,
                  userType: [USER_TYPE.SMB, USER_TYPE.XBPSMB],
                  routes: {
                    scanQRcodeRoute: {
                      path: `/smb/scan-qr-code`,
                      label: "Scan QR Code",
                      action: "scanQRcodeAction",
                    },
                    organizationRoute: {
                      path: `/smb/switch-organizations`,
                      action: "switchOrganizations",
                      label: "Organizations",
                    }
                  }
                },
                approveBillNavigator: {
                  type: "stack",
                  label: "Approve Bill",
                  icon: "cloudSync",
                  iconPath: icBillRequestW,
                  whiteIconPath: icBillRequestW,
                  blueIconPath: icBillRequestW,
                  userType: [USER_TYPE.SMB, USER_TYPE.XBPSMB],
                  routes: {
                    approveBillRoute: {
                      path: `/smb/approve-bill`,
                      label: "Approve Bill",
                      action: "approveBillAction",
                    },
                  },
                },
                makePaymentsNavigator: {
                  type: "stack",
                  label: "Make Payments",
                  icon: "cloudSync",
                  iconPath: icManageProviderB,
                  whiteIconPath: icManageProviderW,
                  blueIconPath: icManageProviderBlue,
                  userType: [USER_TYPE.SMB, USER_TYPE.XBPSMB],
                  routes: {
                    makePaymentsRoute: {
                      path: `/smb/make-payments`,
                      label: "Make Payments",
                      action: "makePaymentsAction",
                    },
                    submittedSmbReceiptRoute: {
                      path: `/smb/submitted-receipt`,
                      label: "Bill Details",
                      action: "submittedSmbReceipt",
                    },
                  },
                },
                vendorStatementsNavigator: {
                  type: "stack",
                  label: "Vendor Statements",
                  icon: "moniter",
                  iconPath: icDashboardB,
                  whiteIconPath: icDashboardW,
                  blueIconPath: icDashboardBlue, 
                  userType: [USER_TYPE.SMB, USER_TYPE.XBPSMB],
                  routes: {
                    vendorStatementsRoute: {
                      path: `/smb/vendor-statements`,
                      label: "Vendor Statements",
                      action: "vendorStatementsAction",
                    },
                  },
                },
                
                receivePaymentsNavigator: {
                  type: "stack",
                  label: "Receive Payments",
                  icon: "cloudSync",
                  iconPath: icManageProviderB,
                  whiteIconPath: icManageProviderW,
                  blueIconPath: icManageProviderBlue,
                  userType: [USER_TYPE.SMB, USER_TYPE.XBPSMB],
                  routes: {
                    receivePaymentsRoute: {
                      path: `/smb/receive-payments`,
                      label: "Receive Payments",
                      action: "receivePaymentsAction",
                    },
                  },
                },
                linkPayerNavigator: {
                  type: "stack",
                  userType: [USER_TYPE.XBP],
                  routes: {
                    linkPayerRoute: {
                      path: "/link-payer",
                      label: "Link Payer",
                      action: "linkPayerAction",
                    },
                  },
                },
                profileViewNavigator: {
                  type: "stack",
                  label: "Profile",
                  icon: "accountCircle",
                  iconPath: icPractitionerProfileB,
                  whiteIconPath: icPractitionerProfileW,
                  blueIconPath: icPractitionerProfileBlue,
                  userType: [USER_TYPE.XBP, USER_TYPE.SMB, USER_TYPE.XBPSMB],
                  routes: {
                    profileViewRoute: {
                      path: `/profile-view`,
                      label: "Profile",
                      action: "profileViewAction",
                    },

                    profileEditRoute: {
                      path: `/profile-edit`,
                      label: "Edit Profile",
                      action: "profileEditAction",
                    },
                  },
                },
                myPreferencesNavigator: {
                  type: "stack",
                  // label: "My Preferences",
                  // icon: "settings",
                  iconPath: "icMyPreferencesB.png",
                  whiteIconPath: "icMyPreferencesW.png",
                  userType: [USER_TYPE.XBP],
                  routes: {
                    myPreferencesViewRoute: {
                      path: `/my-preferences`,
                      label: "My Preferences",
                      action: "myPreferencesAction",
                    },
                  },
                },
                loginOut: {
                  path: "/logout",
                  label: "Logout",
                  icon: "lock",
                  iconPath: icLogoutB,
                  whiteIconPath: icLogoutW,
                  userType: [USER_TYPE.XBP, USER_TYPE.SMB, USER_TYPE.XBPSMB, USER_TYPE.PCH_PATIENT, USER_TYPE.PCH_PROVIDER],
                  action: "logout",
                  metadata: {
                    public: true,
                  },
                  state: {
                    isLogout: true,
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  modal: {
    type: "modal",
    initialRoute: "dashboard",
    modal: {},
    header: {},
    routes: {
      payNowRoutes: {
        title: "Pay Now",
        path: "/paynow",
        initialParentRoute: "dashboard",
        action: "payNowAction",
      },
      clientEdit: {
        title: "Edit Client",
        path: "/client/edit/:uid",
        initialParentRoute: "clients",
      },
      userCreate: {
        title: "Create User",
        path: "/user/create",
        initialParentRoute: "users",
        action: "userEdit",
      },
      userEdit: {
        title: "Edit User",
        path: "/user/edit/:uid",
        initialParentRoute: "users",
      },
      clientAdd: {
        title: "Client add",
        path: "/user/edit/:uid",
        initialParentRoute: "payNowNavigator",
      },
      declinedBlockModalRoute: {
        title: "Declined Block",
        path: "/declined/:paytype",
        initialParentRoute: "declinedRoute",
      },
    },
  },
};

export default routes;